import { bindRequestLogic } from './utils'
import MostFrequentQuestionTypes from '../actionTypes/mostFrequentQuestion'
import { mostFrequentQuestionAPI } from '../api'

const getMostFrequentQuestions = bindRequestLogic({
  clientFunc: mostFrequentQuestionAPI.getMostFrequentQuestions,
  type: MostFrequentQuestionTypes.GET_MOST_FREQUENT_QUESTIONS_REQUEST,
  successType: MostFrequentQuestionTypes.GET_MOST_FREQUENT_QUESTIONS_SUCCESS,
  failType: MostFrequentQuestionTypes.GET_MOST_FREQUENT_QUESTIONS_FAILED,
  isQueryParam: true
})

const addMostFrequentQuestion = bindRequestLogic({
  clientFunc: mostFrequentQuestionAPI.addMostFrequentQuestion,
  type: MostFrequentQuestionTypes.ADD_MOST_FREQUENT_QUESTION_REQUEST,
  successType: MostFrequentQuestionTypes.ADD_MOST_FREQUENT_QUESTION_SUCCESS,
  failType: MostFrequentQuestionTypes.ADD_MOST_FREQUENT_QUESTION_FAILED
})

const updateMostFrequentQuestion = bindRequestLogic({
  clientFunc: mostFrequentQuestionAPI.updateMostFrequentQuestion,
  type: MostFrequentQuestionTypes.UPDATE_MOST_FREQUENT_QUESTION_REQUEST,
  successType: MostFrequentQuestionTypes.UPDATE_MOST_FREQUENT_QUESTION_SUCCESS,
  failType: MostFrequentQuestionTypes.UPDATE_MOST_FREQUENT_QUESTION_FAILED
})

const updateMostFrequentQuestionStatus = bindRequestLogic({
  clientFunc: mostFrequentQuestionAPI.updateMostFrequentQuestionStatus,
  type: MostFrequentQuestionTypes.UPDATE_MOST_FREQUENT_QUESTION_STATUS_REQUEST,
  successType:
    MostFrequentQuestionTypes.UPDATE_MOST_FREQUENT_QUESTION_STATUS_SUCCESS,
  failType:
    MostFrequentQuestionTypes.UPDATE_MOST_FREQUENT_QUESTION_STATUS_FAILED
})

const getMostFrequentQuestionDetail = bindRequestLogic({
  clientFunc: mostFrequentQuestionAPI.getMostFrequentQuestion,
  type: MostFrequentQuestionTypes.GET_MOST_FREQUENT_QUESTION_DETAIL_REQUEST,
  successType:
    MostFrequentQuestionTypes.GET_MOST_FREQUENT_QUESTION_DETAIL_SUCCESS,
  failType: MostFrequentQuestionTypes.GET_MOST_FREQUENT_QUESTION_DETAIL_FAILED
})

const deleteMostFrequentQuestion = bindRequestLogic({
  clientFunc: mostFrequentQuestionAPI.deleteMostFrequentQuestion,
  type: MostFrequentQuestionTypes.DELETE_MOST_FREQUENT_QUESTION_REQUEST,
  successType: MostFrequentQuestionTypes.DELETE_MOST_FREQUENT_QUESTION_SUCCESS,
  failType: MostFrequentQuestionTypes.DELETE_MOST_FREQUENT_QUESTION_FAILED
})

const upsertContentTranslation = bindRequestLogic({
  clientFunc: mostFrequentQuestionAPI.upsertMostFrequentQuestionContent,
  type: MostFrequentQuestionTypes.UPSERT_MOST_FREQUENT_QUESTION_TRANSLATION_REQUEST,
  successType:
    MostFrequentQuestionTypes.UPSERT_MOST_FREQUENT_QUESTION_TRANSLATION_SUCCESS,
  failType:
    MostFrequentQuestionTypes.UPSERT_MOST_FREQUENT_QUESTION_TRANSLATION_FAILED
})

const getMostFrequentQuestionContent = bindRequestLogic({
  clientFunc: mostFrequentQuestionAPI.getMostFrequentQuestionContent,
  type: MostFrequentQuestionTypes.GET_MOST_FREQUENT_QUESTION_CONTENT_REQUEST,
  successType:
    MostFrequentQuestionTypes.GET_MOST_FREQUENT_QUESTION_CONTENT_SUCCESS,
  failType: MostFrequentQuestionTypes.GET_MOST_FREQUENT_QUESTION_CONTENT_FAILED
})

export default [
  getMostFrequentQuestions,
  addMostFrequentQuestion,
  deleteMostFrequentQuestion,
  updateMostFrequentQuestion,
  updateMostFrequentQuestionStatus,
  getMostFrequentQuestionDetail,
  upsertContentTranslation,
  getMostFrequentQuestionContent
]
